import React, { useMemo } from 'react';
import PageContent from 'components/enrollment/contribution-form';
import ContributionFormPageStore, {
  ContributionFormPageStoreContext,
} from 'store/pages/enrollment/contribution-form/contributionFormPageStore';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';

const ContributionFormPage: React.FC = () => {
  const { groupId, periodId } = useEnrollmentDomainParams();
  const pageStore = useMemo(() => new ContributionFormPageStore({ groupId, periodId }), [groupId, periodId]);

  return (
    <ContributionFormPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </ContributionFormPageStoreContext.Provider>
  );
};

export default ContributionFormPage;
